<template>
  <div id="app">
    <v-app>
      <v-content>
      <component :is="layout">
        <router-view :T_DisplayPeriod=this.T_Period></router-view>
      </component>
      <PopInfo ref="info"></PopInfo>
      <PopConfirm ref="confirm"></PopConfirm>
      </v-content>
    </v-app>
  </div>
</template>

<script>
    import PopInfo from "@/components/PopInfo";
    import PopConfirm from "@/components/PopConfirm";

export default {
  components: {
      PopInfo,
      PopConfirm
  }, 
  props : { T_DisplayPeriod : { type : Text } },
  mounted() {
    //this.$router.push({ name: "Connect" }); // Redirections
  },
  watch: {
    '$route' (to) { document.title = to.meta.title || 'Engagement' }
  },
  computed: {
    layout() {
      return this.$route.meta.layout;
    }
  }, 
  methods: {
    IsisInfo(msg, type) {
        this.$refs.info.show(msg, type);
    },       
    IsisConfirm(title, msg, ok, cancel) {
      return this.$refs.confirm.show(title, msg, ok, cancel);
    }
  },
  created(){
      //alert('App : ' + this.T_Period );
      this.T_Period = 'From App';
  }
};
</script>
